export const experienceData = [
    {
        id: 1,
        company: 'Khoros R&D',
        jobtitle: 'SE II',
        startYear: '2021',
        endYear: 'present'
    },
    {
        id: 2,
        company: 'Nineleaps Pvt Ltd',
        jobtitle: 'SE I',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 3,
        company: 'Nineleaps Pvt Ltd',
        jobtitle: 'MTS III',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 4,
        company: 'Nineleaps Pvt Ltd',
        jobtitle: 'MTS II',
        startYear: '2019',
        endYear: '2019'
    },
]